import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "places-dtm"
}

import { onMounted, computed, ref } from 'vue';
import { useRoute } from 'vue-router';

import axios from '@nextcloud/axios';
import NcButton from '@nextcloud/vue/components/NcButton';

import { API } from '@services/API';
import { useRouteIs } from '@services/route-is';
import { routes } from '@services/router';
import { useRouteState } from '@services/route-state';
import { isAbortError, useAbort } from '@services/utils/abort-vue';
import * as utils from '@services/utils/common';

import type { ICluster } from '@typings';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'PlacesDynamicTopMatter',
},
  __name: 'PlacesDynamicTopMatter',
  emits: ["load"],
  setup(__props, { expose: __expose, emit: __emit }) {



const emit = __emit;

const route = useRoute();
const routeIs = useRouteIs();

const places = ref<ICluster[] | null>(null);
const abort = useAbort();

useRouteState({
  state: { places },
});

const isAvailable = computed((): boolean => !routeIs.PlacesUnassigned);
const isReady = computed((): boolean => !isAvailable.value || places.value !== null);
const isContent = computed((): boolean => !!places.value?.length);

const placeId = computed((): number => {
  return Number(utils.routeParamToString(route.params.name).split('-')[0]) || -1;
});

async function refresh(): Promise<void> {
  // Skip if unidentified location view
  if (!isAvailable.value) return;

  // Get ID of place from URL
  const placeIdVal = placeId.value;
  const url = API.Q(API.PLACE_LIST(), { inside: placeIdVal });
  const signal = abort.renew();

  // Make API call to get subplaces
  try {
    const data = (await axios.get<ICluster[]>(url, { signal })).data;
    signal.throwIfAborted();
    places.value = data;
    emit('load');
  } catch (e) {
    if (isAbortError(e)) return;
    console.error(e);
  } finally {
    if (!signal.aborted) {
      places.value ??= [];
    }
  }
}

function routeTo(place: ICluster) {
  return {
    name: routes.Places.name,
    params: {
      name: place.cluster_id + '-' + place.name,
    },
  };
}

onMounted(refresh);

__expose({ isReady, isContent, refresh });

return (_ctx: any,_cache: any) => {
  return (isReady.value && isContent.value && places.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(places.value, (place) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "place-btn",
            key: place.cluster_id
          }, [
            _createVNode(_unref(NcButton), {
              class: "place",
              to: routeTo(place)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(place.name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})